import { render, staticRenderFns } from "./ContactsTable.bkp.vue?vue&type=template&id=8471af1e&"
import script from "./ContactsTable.bkp.vue?vue&type=script&lang=js&"
export * from "./ContactsTable.bkp.vue?vue&type=script&lang=js&"
import style0 from "./ContactsTable.bkp.vue?vue&type=style&index=0&id=8471af1e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports